<template>
  <div class="relative">
    <swiper class="swiper" :options="swiperOptions">
      <!-- <swiper-slide
        class="sm-h600"
        v-for="item in get_AllBanner"
        :key="item.objectId"
        @click="toggleDetails(true, item)"
      >
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="
              min-hidden
              w-80per
              absolute
              top-0
              right-0
              line-bgh-525px
              z-index--1
            "
          />
          <div
            class="
              lg:w-1/2
              md:w-1/2
              w-full
              relative
              md:hidden
              lg:hidden
              block
              lg:top-0
              md:top-0
              top-72
            "
          >
            <img
              src="../../../assets/images/swiper-img/home-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                ml-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  font-semibold
                  fsize35
                  sm-fsize24
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  lg:w-full
                  md:w-full
                "
              >
                About our Services
              </p>

              <p
                class="
                  fsize25
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                "
              >
                Get access to exclusive tools, tips, and benefits
                <a
                  @click.stop="handleClick('register')"
                  class="
                    underline
                    text-4f0a4b
                    min-hidden
                    font-semibold
                    cursor-pointer
                  "
                  >Register</a
                >
              </p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  @click="handleClick('register')"
                  type="primary"
                  class="cust-btn-wh btntext"
                  >Register</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/help frame.svg"
              class="w-full absolute min-top8rem min-h-86per"
              alt=""
            />
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon "
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img src="../../../assets/images/bg-des/s2tr.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="
              min-hidden
              w-80per
              absolute
              top-0
              right-0
              line-bgh-525px
              z-index--1
            "
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/cp-bg-l.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/swpr2.svg"
              class="
                w-full
                absolute
                min-top8rem min-h-86per
                md:block
                lg:block
                hidden
              "
              alt=""
            />
            <img
              src="../../../assets/images/swiper-img/home-mob-2.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                mr-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  font-semibold
                  fsize35
                  sm-fsize24
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  lg:w-full
                  md:w-full
                "
              >
                We UNDERSTAND Caregivers and Caregiving…You are NOT alone
              </p>
              <p
                class="
                  fsize25
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                "
              >
                Explore ways to become more effective and focus on yourself.
                <span
                  @click.stop="handleClick('caregiver')"
                  class="
                    underline
                    text-4f0a4b
                    min-hidden
                    font-semibold
                    cursor-pointer
                  "
                  >Know more</span
                >
              </p>

              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="cust-btn-wh btntext"
                  @click="handleClick('caregiver')"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="
              min-hidden
              w-80per
              absolute
              top-0
              right-0
              line-bgh-525px
              z-index--1
            "
          />
          <div
            class="
              lg:w-1/2
              md:w-1/2
              w-full
              relative
              md:hidden
              lg:hidden
              block
              lg:top-0
              md:top-0
              top-72
            "
          >
            <img
              src="../../../assets/images/swiper-img/home-mob-3.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                ml-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  font-semibold
                  fsize35
                  sm-fsize24
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  lg:w-full
                  md:w-full
                "
              >
                About our Services
              </p>
              <p
                class="
                  fsize25
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                "
                @click="handleClick('wellwisher')"
              >
                Identify what you can do to help someone through your support or
                gift a service!
                <span
                  @click="handleClick('wellwisher')"
                  class="
                    underline
                    text-4f0a4b
                    min-hidden
                    font-semibold
                    cursor-pointer
                  "
                  >Know more</span
                >
              </p>
              <div
                class="flex lg:pt-8 md:pt-8 mob-hidden"
                @click="handleClick('wellwisher')"
              >
                <base-button type="primary" class="cust-btn-wh btntext"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/swpr3.svg"
              class="w-full absolute min-top8rem min-h-86per"
              alt=""
            />
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img src="../../../assets/images/bg-des/s2tr.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="
              min-hidden
              w-80per
              absolute
              top-0
              right-0
              line-bgh-525px
              z-index--1
            "
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/cp-bg-l.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/swpr4.svg"
              class="
                w-full
                absolute
                min-top8rem min-h-86per
                md:block
                lg:block
                hidden
              "
              alt=""
            />
            <img
              src="../../../assets/images/swiper-img/home-mob-4.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                mr-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  font-semibold
                  fsize35
                  sm-fsize24
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  lg:w-full
                  md:w-full
                "
              >
                About our Services
              </p>
              <p
                class="
                  fsize25
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                "
              >
                It is challenging to maintain the ability to provide
                professional care continuously – Your well-being matters too.
                <span
                  @click="handleClick('hcp')"
                  class="
                    underline
                    text-4f0a4b
                    min-hidden
                    font-semibold
                    cursor-pointer
                  "
                  >Know more</span
                >
              </p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="cust-btn-wh btntext"
                  @click="handleClick('hcp')"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide> -->

      <swiper-slide
        class=""
        v-for="item in get_AllBanner"
        :key="item.objectId"
        @click="toggleDetails(true, item)"
      >
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div
          class="lg:flex md:flex lg:gap-10 md:gap-10 lg:pt-32 md:pt-32 lg:px-20 md:px-20 px-5"
        >
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative md:hidden lg:hidden block lg:top-0 md:top-0 top-72"
          >
            <!-- <img
              class="w-full absolute md:hidden lg:hidden block object-cover"
            /> -->
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-10 md:mt-10 mt-28">
            <div class="">
              <p
                class="font-semibold fsize30-20px sm-fsize25 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                Caregiver Coaching: Safe spaces for building skills that
                Caregiving demands
                <!-- {{ item.heading }} -->
              </p>
              <p
                class="fsize16 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Ensuring long-term caregiving can be challenging at multiple
                levels. The Caregiver Coach certification provides coaches with
                a framework to help family caregivers navigate their
                unpredictable, challenging and isolating journeys in a manner
                that irrespective of these challenges, they can live full lives.
                <!-- {{ item.discription }} -->
                <!-- <span
                  @click="handleClick('corporate')"
                  class="
                    underline
                    text-4f0a4b
                    min-hidden
                    font-semibold
                    cursor-pointer
                  "
                  >Know more</span
                > -->
              </p>
              <p
                class="fsize16 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 mt-2"
              >
                Join us on this collective journey to lend your expertise as a
                coach, a psychologist or a therapist to support Family
                Caregivers.
              </p>
              <!-- <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="cust-btn-wh btntext"
                  @click="handleClick('corporate')"
                  >Know more</base-button
                  src="../../../assets/images/swiper-img/home-mob-5.svg"
                   alt="swiper-img"
                    src="../../../assets/images/swpr5.svg"
                >
              </div> -->
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/JoinUs/Become-a-Caregiver-Coach-Banner.jpg"
              alt="cp bg"
              class="lg:ml-20 custborderradius object-cover relative h-350px lg:px-0 md:px-0 px-4 lg:mt-20 md:mt-20 mt-4 bg-white"
            />
            <!-- <img
              class="w-full absolute min-top8rem min-h-86per max-height296px"
              :src="hasError ? defaultImage : image(item.image)"
              :alt="item.heading"
            /> -->
          </div>
        </div>
      </swiper-slide>

      <!-- <div
        class="swiper-pagination cust-posi dot-shift"
        slot="pagination"
      ></div> -->
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },

      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async function() {
      let payload = "testing";
      await this.$store.dispatch("services/getbanner");
    },
    image(x) {
      return `${this.$imageURL}/${x}`;
    },
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedExclusive = item;
    },
  },
  computed: {
    ...mapState("services", { get_AllBanner: "get_AllBanner" }),
  },
  mounted() {
    this.function();
  },
};
</script>
<style scoped lang="scss">
.h-350px {
  height: 350px;
}
.max-height296px {
  @media (max-width: 575px) {
    height: 296px;
  }
}
</style>
